import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=24be396b&scoped=true&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=24be396b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be396b",
  null
  
)

export default component.exports